<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "TaskType",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'orderType:add',
                    update: 'orderType:update',
                    delete: 'orderType:delete',
                    deleteBatch: 'orderType:deleteBatch'
                },
                url: {
                    get: '/orderType/listByCondition',
                    add: '/orderType/add',
                    update: '/orderType/update',
                    delete: '/orderType/delete/',
                    delete_batch: '/orderType/deleteBatch',
                    status: '/orderType/status'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'name',
                    label: '分类名称',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: true,
                    width: '90',
                    status: true,
                }],
                formFields: {
                    addTitle: '添加订单分类',
                    updateTitle: '修改订单分类',
                    labelWidth: '105px',
                    model: [{
                        field: 'name',
                        label: '分类名称：',
                        type: 'input',
                        placeholder: '分类名称',
                        rules:[{required: true, message: '请输入分类名称', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }],
                },
                operate: [],
            }
        }
    }
</script>

<style scoped>

</style>
